import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { Textarea } from 'primeng/textarea';
import Sample from '../../../../../../types/sample/Sample';
import VehicleModel from '../../../../../../types/vehicle-model/VehicleModel';
import { VehicleModelService } from '../../../../services/vehicle-model.service';

@Component({
    selector: 'app-change-sales-codes-dialog',
    imports: [
        FormsModule,
        Dialog,
        Button,
        IftaLabelModule,
        Textarea
    ],
    templateUrl: './change-sales-codes-dialog.component.html',
    styleUrls: [ './change-sales-codes-dialog.component.scss' ]
})
export class ChangeSalesCodesDialogComponent implements OnChanges {

    @Input() public visible: boolean = false;
    @Input() public sample: Sample | null = null;
    @Input() public vehicleModel: VehicleModel | null = null;

    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public salesCodesChange: EventEmitter<void> = new EventEmitter<void>();

    public salesCodes: string = '';

    public loading: boolean = false;

    constructor(private vehicleModelService: VehicleModelService,
                private messageService: MessageService) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue === true) {
            this.salesCodes =
                ( this.vehicleModel && this.vehicleModel.salesCodes ) ? this.vehicleModel.salesCodes.join(', ') : '';
        }
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public save(): void {
        this.loading = true;

        // Split the input string by commas, trim each entry, and filter out any empty strings.
        const codes: string[] = this.salesCodes
            .split(',')
            .map(code => code.trim())
            .filter(code => code.length > 0);

        // Update the sales codes for the sample.
        this.vehicleModelService.changeSampleSalesCodes(this.vehicleModel!.id, this.sample!.id, codes)
            .then(() => {
                this.messageService.add(
                    { severity: 'success', summary: 'Success', detail: 'Sales codes updated successfully.' });
                this.salesCodesChange.emit();
                this.close();
            }).catch((error: any) => {
            this.messageService.add(
                { severity: 'error', summary: 'Failed to update sales codes', detail: error.message });
            console.error('Failed to update sales codes:', error);
        }).finally(() => {
            this.loading = false;
        });
    }

}
